import { __awaiter, __generator, __read } from "tslib";
import { useEffect, useState } from 'react';
import { findAppDefinitionById } from '../findAppDefinitionById';
/**
 * @description Get Application definition based on appId
 * @param appId used to search for app definition
 * @returns UseAppDefinitionResult
 */
export var useAppDefinitionById = function (appId) {
    var _a = __read(useState(undefined), 2), appDefinition = _a[0], setAppDefinition = _a[1];
    var _b = __read(useState(false), 2), missingAppDefinition = _b[0], setMissingAppDefinition = _b[1];
    useEffect(function () {
        var isMounted = true;
        var fetchDefinition = function () { return __awaiter(void 0, void 0, void 0, function () {
            var fetchedAppDefinition;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!appId) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, findAppDefinitionById(appId)];
                    case 1:
                        fetchedAppDefinition = _a.sent();
                        if (isMounted) {
                            if (!fetchedAppDefinition) {
                                setMissingAppDefinition(true);
                            }
                            else {
                                setAppDefinition(fetchedAppDefinition);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        fetchDefinition();
        return function () {
            isMounted = false;
        };
    }, [appId]);
    return { appDefinition: appDefinition, missingAppDefinition: missingAppDefinition };
};
//# sourceMappingURL=useAppDefinitionById.js.map